'use client';

import styled from '@emotion/styled';
import { Section } from '../../content-sections/ui/components/Section';
import { CookiebotDeclarationScript } from '../../shared/cookie-bot/CookiebotDeclarationScript';

/** Collapses along with the declaration, so a hidden one leaves no blank band. */
const CookiebotSection = styled(Section)`
	&:has(> [hidden]) {
		padding: 0;
	}
`;

export default function PrivacyPolicyPage() {
	return (
		<CookiebotSection>
			<CookiebotDeclarationScript />
		</CookiebotSection>
	);
}
